import { Signer } from '@ethersproject/abstract-signer'
import { verifyMessage } from '@ethersproject/wallet'
import { EthAddress } from '@xylabs/sdk-js'
import { Buffer } from 'buffer/'
import { CookieStorage } from 'cookie-storage'
import { DateTime } from 'luxon'

class XyoWorldAuthentication {
  private static cookieName = 'authToken'
  private static signInMessage = 'Welcome to XYO World' //this has to stay the same since we check signature against it
  public token?: string
  private signer: Signer

  constructor(signer: Signer) {
    this.signer = signer
    this.readToken()
  }

  public address() {
    const signature = this.token ? `0x${Buffer.from(this.token, 'base64').toString('hex')}` : null
    return signature ? EthAddress.fromString(verifyMessage(XyoWorldAuthentication.signInMessage, signature)) : null
  }

  public authenticated() {
    return !!this.token
  }

  public async signIn() {
    try {
      this.token = Buffer.from((await this.signer.signMessage(XyoWorldAuthentication.signInMessage)).slice(2), 'hex').toString('base64')
    } catch (ex) {
      console.error(`SignIn: ${ex}`)
      this.token = undefined
    }
    this.storeToken()
    return this
  }

  public signOut() {
    this.token = undefined
    this.storeToken()
    return this
  }

  private readToken() {
    const cookieStorage = new CookieStorage()
    this.token = cookieStorage.getItem(XyoWorldAuthentication.cookieName) ?? undefined
    return this
  }

  private storeToken() {
    const cookieStorage = new CookieStorage()
    if (this.token) {
      cookieStorage.setItem(XyoWorldAuthentication.cookieName, this.token, {
        expires: DateTime.local().plus({ weeks: 1 }).toJSDate(),
        path: '/',
      })
    } else {
      cookieStorage.removeItem(XyoWorldAuthentication.cookieName, {
        path: '/',
      })
    }
    return this
  }
}

export default XyoWorldAuthentication
